import React from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';
import {Field, reduxForm} from 'redux-form';
import InputField from '../../../shared/form-elements/input';

import './two-factor-authentication.less';

const TwoFactorAuthenticationForm = (props) => {
	const {
		handleSubmit,
		initTwoFactorAuthentication,
		activateTwoFactorAuthentication,
		finishTwoFactorAuthentication,
		deactivateTwoFactorAuthentication,
		twoFactorAuthenticationForm,
		data,
		intl
	} = props;
	const {step,
		otpauth_url,
		secret,
		two_factor_recovery_codes
	} = twoFactorAuthenticationForm;
	const {
		is_two_factor_authentication_enabled
	} = data.profile;

	const googleAppUrl = 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2';
	const iTunesAppUrl = 'http://itunes.apple.com/ru/app/google-authenticator/id388497605';

	return (
		<div>
			{!is_two_factor_authentication_enabled && step === 1 &&<div className="profile-wrap__form-field clearfix">
				<p>{intl('Обезопасьте свой аккаунт с двухфакторной аутентификацией')}</p>
				<p>{intl('Каждый раз, когда вы входите в свою учетную запись, вам нужен ваш пароль и код подтверждения.')}</p>
				<button
					className="button yellow-btn profile-change-btn font-proxima-nova-semibold"
					onClick={() => initTwoFactorAuthentication()}>
					{intl('Начать установку')}
				</button>
			</div>}
			{!is_two_factor_authentication_enabled && step === 2 && <div>
				<form action="#"
					className="profile__2fa half-width clearfix"
					onSubmit={handleSubmit(formData => activateTwoFactorAuthentication(formData))}
				>
					<p>
						{intl('Скачайте приложение на телефон Google Authenticator из ')}
						<a href={googleAppUrl} target='_blank'>
							Google Play
						</a> {intl(' или ')}
						<a href={iTunesAppUrl} target='_blank'>
							App Market
						</a>
					</p>
					<p>{intl('В приложении выберите "Добавить Аккаунт"')}</p>
					<p>{intl('Выберите "Сканировать QR код"')}</p>
					{otpauth_url && <QRCode value={otpauth_url}/>}
					<p>{intl('или введите секретное значение вручную:')} "{secret}"</p>
					<p>{intl('Введите код с приложения')}</p>
					<div  className="profile-wrap__form-field profile-wrap__form-field-token">
						<Field name="token"
							placeholder={intl('Код подтверждения')}
							component={InputField}
							shouldDisable={false}
							type="text"
						/>
					</div>
					<button className="button yellow-btn profile-change-btn font-proxima-nova-semibold" type="submit">
						{intl('Включить')}
					</button>
				</form>
			</div>}
			{is_two_factor_authentication_enabled && step === 3 && <div>
				<p>{intl('Двухфакторная аутентификация активирована. Сохраните коды восстановления на случай утери' +
					' доступу к аутентификатору и используйте их вместо токена.')}</p>
				<p className="important-note">
					{intl('Если на форме логина нет поля для ввода токена то пароль нужно будет вводить в формате' +
						' "XXYY", где XX - ваш обычный пароль и YY - динамический токен с аутентификатора')}
				</p>
				<pre>
					{two_factor_recovery_codes.join('\n')}
				</pre>
				<button
					className="button yellow-btn profile-change-btn font-proxima-nova-semibold"
					onClick={() => finishTwoFactorAuthentication()}>
					{intl('Завершить')}
				</button>
			</div>}
			{is_two_factor_authentication_enabled && step !== 3 && <div>
				<p>{intl('Двухфакторная аутентификация активна')}</p>
				<p className="important-note">
					{intl('Если на форме логина нет поля для ввода токена то пароль нужно будет вводить в формате' +
					' "XXYY", где XX - ваш обычный пароль и YY - динамический токен с аутентификатора')}
				</p>
				<button
					className="button yellow-btn profile-change-btn font-proxima-nova-semibold"
					onClick={() => deactivateTwoFactorAuthentication()}>
					{intl('Выключить')}
				</button>
			</div>}
		</div>
	);
};

TwoFactorAuthenticationForm.propTypes = {
	initTwoFactorAuthentication: PropTypes.func,
	activateTwoFactorAuthentication: PropTypes.func,
	deactivateTwoFactorAuthentication: PropTypes.func,
	finishTwoFactorAuthentication: PropTypes.func,
	handleSubmit: PropTypes.func,
	intl: PropTypes.func,
	twoFactorAuthenticationForm: PropTypes.object,
	data: PropTypes.object
};

export default reduxForm({
	form: 'profileTwoFactorAuthenticationForm'
})(TwoFactorAuthenticationForm);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/profile/components/forms/two-factor-authentication.js